/**
 * Created by Ivan on 09.09.2026
 */

const StickersBook2Merge2Adapter = {
    SubscribeToEvents: function () {
        cleverapps.eventBus.on("stickers2_add_fly_icon", () => {
            const sceneComponent = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent);
            if (sceneComponent && !sceneComponent.stickersBookFlyIcon) {
                const icon = sceneComponent.stickersBookFlyIcon = new StickersBookFlyIcon2();
                icon.setLocalZOrder(WindowComponent.WINDOWS_ZORDER + 1);
                sceneComponent.node.addChild(icon);
            }
        });

        cleverapps.eventBus.on("stickers2_unit_clicked", (unit) => {
            cleverapps.focusManager.display({
                focus: "StickersUnitLibraryWindow",
                stack: true,
                action: function (f) {
                    new Merge2UnitsLibraryWindow(unit);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        });

        cleverapps.eventBus.on("stickers2_book_entry_force", () => {
            cleverapps.focusManager.hideControlsWhileFocused(["backpackButton", "unitInfoView"]);
            cleverapps.focusManager.showControlsWhileFocused("toolbar");

            Merge2.current.changeMode(Merge2.MODE_META, () => {
                const view = cleverapps.toolbar.getItem(ToolbarItem.STICKERS_BOOK2.type).onGetView();

                cleverapps.forces.create(view, { finger: true, shadow: false }, {
                    importantNodes: [ComponentUtils.findChildByName(cleverapps.Scenes.GetRunningScene(), "toolbar")],
                    onSkip: () => cleverapps.tutorial.skip()
                });
            });
        });
    }
};

cleverapps.whenAllInitialized(() => StickersBook2Merge2Adapter.SubscribeToEvents());
